import SampleResultRepository from './SampleResultRepository'

const repositories = {
  sampleResult: SampleResultRepository
}

export const ResultRepositoryFactory = {
  get: name => repositories[name]
}
